export default __webpack_public_path__ + "static/media/jewelry-cold-winter.cd98b376.png";